/* import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Callback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const getTokenAndPostBlog = async () => {
      const code = new URLSearchParams(window.location.search).get("code");

      if (!code) {
        console.error("Missing 'code' in URL");
        return;
      }

      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';

      try {
        // 1. Get token from backend
        const res = await fetch(`${apiUrl}/api/wordpress/get-token`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code }),
        });

        if (!res.ok) throw new Error(await res.text());

        const data = await res.json();
        localStorage.setItem('wp_token', data.access_token);
        localStorage.setItem('wp_site', new URL(data.blog_url).host);

        // 2. Now post the blog
        await postToWordPress(data.access_token, data.blog_url);

        // 3. Done, go back to home
        navigate('/');
      } catch (error) {
        console.error("WordPress auth or post failed:", error);
      }
    };

    const postToWordPress = async (accessToken: string, blogUrl: string) => {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';

      const blogData = {
        title: "My Awesome Blog",
        content: "<p>This is the content of the blog.</p>",
        status: "publish",
      };

      const res = await fetch(`${apiUrl}/api/wordpress/post-blog`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ ...blogData, blog_url: blogUrl }),
      });

      if (!res.ok) {
        const error = await res.text();
        throw new Error(`Blog post failed: ${error}`);
      }

      const postResult = await res.json();
      console.log("✅ Blog posted:", postResult);
    };

    getTokenAndPostBlog();
  }, [navigate]);

  return <div>Posting your blog to WordPress...</div>;
};

export default Callback; */
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const Callback = () => {
  const navigate = useNavigate();
  const hasFetched = useRef(false);

  useEffect(() => {
    const getToken = async () => {

      if (hasFetched.current) return;
      hasFetched.current = true;

      const code = new URLSearchParams(window.location.search).get("code");

      if (!code) {
        console.error("Missing 'code' in URL");
        return;
      }

      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';

      try {
        const res = await fetch(`${apiUrl}/api/wordpress/get-token`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code }),
        });

        if (!res.ok) throw new Error(await res.text());

        const data = await res.json();
        localStorage.setItem('wp_token', data.access_token);
        localStorage.setItem('wp_site', new URL(data.blog_url).host);
        localStorage.setItem('trigger_wp_post', 'true');
        navigate('/codegenie/generated-blogs'); // Redirect to listing page
      } catch (error) {
        console.error("WordPress auth failed:", error);
      }
    };

    getToken();
  }, [navigate]);

  return <div>Authenticating with WordPress...</div>;
};

export default Callback;